var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    { staticClass: "tabs", attrs: { type: "border-card" } },
    [
      _c(
        "el-tab-pane",
        { attrs: { label: _vm.$t("basicData.regionalInformation") } },
        [_c("Region")],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { label: _vm.$t("basicData.icmsTaxReferenceTable") } },
        [_c("ICMS")],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { label: _vm.$t("basicData.inlandWaterwayTransportFee") } },
        [_c("TransportationFee")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }